import { useState, type JSX } from 'react';
import type { MediaVideoInfo } from '@/services/slaydAPI/posts';
import styles from '../ApprovalPortalPage.module.css';

interface PostMediaProps {
  postType: 'INSTA_POST' | 'INSTA_REEL';
  mediaImages: string[];
  mediaVideo?: MediaVideoInfo;
}

export const PostMedia = ({
  postType,
  mediaImages,
  mediaVideo,
}: PostMediaProps): JSX.Element => {
  const [index, setIndex] = useState(0);

  if (postType === 'INSTA_REEL' && mediaVideo) {
    return (
      <div className={styles.card}>
        <video
          controls
          className={styles.videoPlayer}
          poster={mediaVideo.thumbnailUrl || undefined}
          src={mediaVideo.url}
        >
          Your browser does not support the video tag.
        </video>
      </div>
    );
  }

  if (mediaImages.length === 0) {
    return (
      <div className={`${styles.card} ${styles.noMedia}`}>
        No media available
      </div>
    );
  }

  const prev = (): void =>
    setIndex((i) => (i - 1 + mediaImages.length) % mediaImages.length);
  const next = (): void => setIndex((i) => (i + 1) % mediaImages.length);

  return (
    <div className={styles.carousel}>
      <img
        alt={`Post image ${index + 1}`}
        className={styles.carouselImg}
        src={mediaImages[index]}
      />

      {mediaImages.length > 1 && (
        <>
          <button
            className={`${styles.carouselBtn} ${styles.carouselBtnPrev}`}
            onClick={prev}
          >
            ‹
          </button>
          <button
            className={`${styles.carouselBtn} ${styles.carouselBtnNext}`}
            onClick={next}
          >
            ›
          </button>
          <div className={styles.carouselDots}>
            {mediaImages.map((_, i) => (
              <button
                key={i}
                className={`${styles.carouselDot} ${i === index ? styles.carouselDotActive : ''}`}
                onClick={() => setIndex(i)}
              />
            ))}
          </div>
          <div className={styles.carouselCounter}>
            {index + 1} / {mediaImages.length}
          </div>
        </>
      )}
    </div>
  );
};
